import { render, staticRenderFns } from "./PlanejamentoForm.vue?vue&type=template&id=16b98ec3&"
import script from "./PlanejamentoForm.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoForm.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports